
import FileInput from "../../../common/input/FileInput";

export default function FieldVideo({ onChange }) {
	return <FileInput onChange={onChange} label="ویدئوی جلسه" accept="video/*" />;
}
